import React, { Fragment, useEffect } from "react";
import PageTitle from "../../layouts/PageTitle";
import { Button, Dropdown } from "react-bootstrap";




import { Link } from "react-router-dom";
import { connect, useDispatch } from "react-redux";


import Pagination from "react-js-pagination";
import { DonetionInitialLoad, DonetionPaggination } from "../../../store/thunk/DonetionThunk";
import { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import PageLoader from "../../layouts/PageLoader";
import { PaymentIsLoading, PaymentListWithPaggination } from "../../../store/selectors/PaymentSelector";
import { PaymentInitialLoad, PaymentPaggination } from "../../../store/thunk/PaymentThunk";
import DateRangePicker from "react-bootstrap-daterangepicker";


const Payments = ({ payments, isLoading }) => {

   // console.log({ donetions });

   const dispatch = useDispatch();

   const [searchQuary, setSearchQuary] = useState("");
   const [dateQuary, setDateQuary] = useState()


   useEffect(() => {
      dispatch(PaymentInitialLoad());
   }, [])

   useEffect(() => {

      if (dateQuary) {
         dispatch(PaymentPaggination({ q: searchQuary, pageNumber: 1, dateQuary }))
      } else {
         dispatch(PaymentPaggination({ q: searchQuary, pageNumber: 1 }))
      }


   }, [searchQuary, dateQuary])

   const clearFilter = () => {
      setSearchQuary("");
      setDateQuary();
   }



   // console.log({ payments, isLoading, dateQuary });





   return (
      <Fragment>
         <PageLoader isLoading={isLoading} >

            {/* <PageTitle activeMenu="Payments List" motherMenu="Payments" /> */}

            <div className="row">
               <div className="col-lg-12">
                  <div className="card">
                     <div className="card-body">
                        <div className="row align-items-end">
                           <div className="col-lg-4">
                              <p className="mb-1">Search by Amount</p>
                              <div className="input-group search-area">

                                 <input type="number"
                                    className={`form-control active`}
                                    placeholder="Search"
                                    onChange={(e) => setSearchQuary(e.currentTarget.value)}
                                    value={searchQuary}
                                 />
                                 <span className="input-group-text" >
                                    <i className="flaticon-381-search-2"></i>
                                 </span>
                              </div>
                           </div>
                           <div className="col-lg-4">
                              <div className="example rangeDatePicker">
                                 <p className="mb-1">Date</p>

                                 <DateRangePicker
                                    onCallback={(start, end, label) => {
                                       setDateQuary({
                                          fromDate: start?.format('YYYY-MM-DD'),
                                          toDate: end?.format('YYYY-MM-DD')
                                       })
                                    }}

                                    initialSettings={{
                                       autoUpdateInput: false,
                                       locale: {
                                          cancelLabel: 'Clear',
                                       },
                                    }}

                                    onApply={(event, picker) => {
                                       picker.element.val(
                                          picker.startDate.format('MM/DD/YYYY') +
                                          ' - ' +
                                          picker.endDate.format('MM/DD/YYYY')
                                       );
                                    }}

                                    onCancel={(event, picker) => {
                                       picker.element.val('');
                                    }}
                                 >
                                    <input type="text" className="form-control input-daterange-timepicker" placeholder="Select Date" />
                                 </DateRangePicker>
                              </div>
                           </div>
                           <div className="col-lg-2">
                              <div className="input-group">

                                 <Button onClick={clearFilter}>Clear Filter</Button>
                              </div>
                           </div>
                        </div>
                        <br />
                        <div className="table-responsive">
                           <table className="table mb-0 table-striped">
                              <thead>
                                 <tr>

                                    <th>Payment Id</th>
                                    <th>Amount Contributed</th>
                                    <th>Date of Donation</th>
                                    <th>Payment Method</th>
                                    <th>Status</th>
                                    <th></th>
                                 </tr>
                              </thead>
                              <tbody id="Payments">

                                 {
                                    payments?.data?.map((payment, index) => (
                                       <tr className="btn-reveal-trigger" key={index}>

                                          <td className="py-3">
                                             <Link to={`/payments-edit/${payment?.id}`}>
                                                <div className="media d-flex align-items-center">

                                                   <div className="media-body">
                                                      <h5 className="mb-0 fs--1">
                                                         #PAYMENT{payment?.id}
                                                      </h5>
                                                   </div>
                                                </div>
                                             </Link>
                                          </td>
                                          <td className="py-2">
                                             ₹{payment?.amount}
                                          </td>

                                          <td className="py-2 ">

                                             {format(new Date(payment?.created_at), "dd-MM-yyyy")}
                                          </td>
                                          <td className="py-2 ">

                                             {payment?.paymentmethod?.name}
                                          </td>
                                          <td className="py-2">
                                             {payment?.donation != null ?
                                                (<span className="badge badge-rounded badge-primary">Payment Linked</span>) :
                                                (<span className="badge badge-rounded badge-warning">Payment Not Linked</span>)}
                                          </td>
                                          <td className="py-2">
                                             <Dropdown>
                                                <Dropdown.Toggle variant="" className="btn btn-primary tp-btn-light sharp i-false">
                                                   <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                                      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                         <rect x="0" y="0" width="24" height="24"></rect>
                                                         <circle fill="#000000" cx="5" cy="12" r="2"></circle>
                                                         <circle fill="#000000" cx="12" cy="12" r="2"></circle>
                                                         <circle fill="#000000" cx="19" cy="12" r="2"></circle>
                                                      </g>
                                                   </svg>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>

                                                   <Dropdown.Item ><Link to={`/payments-edit/${payment?.id}`}>Process </Link></Dropdown.Item>


                                                   {/* <Dropdown.Item href="#" className="text-danger">
                                                      Delete
                                                   </Dropdown.Item> */}
                                                </Dropdown.Menu>
                                             </Dropdown>
                                          </td>

                                       </tr>
                                    ))
                                 }

                              </tbody>
                           </table>
                        </div>
                        <br />
                        <div>
                           <Pagination
                              activePage={payments?.current_page ? payments?.current_page : 0}
                              itemsCountPerPage={payments?.per_page ? payments?.per_page : 0}
                              totalItemsCount={payments?.total ? payments?.total : 0}
                              onChange={(pageNumber) => {
                                 dispatch(PaymentPaggination({ q: searchQuary, pageNumber, dateQuary }))
                              }}
                              pageRangeDisplayed={8}
                              itemClass="page-item"
                              linkClass="page-link"
                              firstPageText="First Page"
                              lastPageText="Last Page"
                           />
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </PageLoader>
      </Fragment>
   );
};


const mapStateToProps = (state) => {
   return {
      payments: PaymentListWithPaggination(state),
      isLoading: PaymentIsLoading(state)
   };
};

export default connect(mapStateToProps)(Payments);


